import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { SchadenmeldungLandApi } from './SchadenmeldungSchadenmeldungLandApi';
import { PersonenAksApi } from './AksPersonenAksApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksUnfall
 * Container für die Daten im Schadensfall Unfall
 * Endpoints: /api/schadenmeldungen/aks
 */
export class SchadenAksUnfallApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenAksUnfallApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected abreisedatum: string;
	/**
	 * Description: Datum der Abreise
	 * APIL Type: date-time
	 */
	get Abreisedatum(): string {
		return this.abreisedatum;
	}

	/**
	 * Description: Datum der Abreise
	 * APIL Type: date-time
	 */
	set Abreisedatum(value: string) {
		this.abreisedatum = value;
	}

	protected datum: string;
	/**
	 * Description: Datum des Schadens
	 * APIL Type: date-time
	 */
	get Datum(): string {
		return this.datum;
	}

	/**
	 * Description: Datum des Schadens
	 * APIL Type: date-time
	 */
	set Datum(value: string) {
		this.datum = value;
	}

	protected land: SchadenmeldungLandApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungLand
	 */
	get Land(): SchadenmeldungLandApi {
		return this.land;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungLand
	 */
	set Land(value: SchadenmeldungLandApi) {
		this.land = value;
	}

	protected betroffenePerson: PersonenAksApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.PersonenAks
	 */
	get BetroffenePerson(): PersonenAksApi {
		return this.betroffenePerson;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.PersonenAks
	 */
	set BetroffenePerson(value: PersonenAksApi) {
		this.betroffenePerson = value;
	}

	protected beschreibung: string;
	/**
	 * Description: stichpunktartige Beschreibung
	 * APIL Type: string
	 */
	get Beschreibung(): string {
		return this.beschreibung;
	}

	/**
	 * Description: stichpunktartige Beschreibung
	 * APIL Type: string
	 */
	set Beschreibung(value: string) {
		this.beschreibung = value;
	}

	protected vorname: string;
	/**
	 * Description: Vorname der Person
	 * APIL Type: string
	 */
	get Vorname(): string {
		return this.vorname;
	}

	/**
	 * Description: Vorname der Person
	 * APIL Type: string
	 */
	set Vorname(value: string) {
		this.vorname = value;
	}

	protected nachname: string;
	/**
	 * Description: Nachname der Person
	 * APIL Type: string
	 */
	get Nachname(): string {
		return this.nachname;
	}

	/**
	 * Description: Nachname der Person
	 * APIL Type: string
	 */
	set Nachname(value: string) {
		this.nachname = value;
	}

	protected zustimmungDatenverarbeitung: boolean;
	/**
	 * Description: der Datenverarbeitung wurde zugestimmt
	 * APIL Type: boolean
	 */
	get ZustimmungDatenverarbeitung(): boolean {
		return this.zustimmungDatenverarbeitung;
	}

	/**
	 * Description: der Datenverarbeitung wurde zugestimmt
	 * APIL Type: boolean
	 */
	set ZustimmungDatenverarbeitung(value: boolean) {
		this.zustimmungDatenverarbeitung = value;
	}

	protected personGemeldet: boolean;
	/**
	 * Description: Person ist am Wohnsitz gemeldet
	 * APIL Type: boolean
	 */
	get PersonGemeldet(): boolean {
		return this.personGemeldet;
	}

	/**
	 * Description: Person ist am Wohnsitz gemeldet
	 * APIL Type: boolean
	 */
	set PersonGemeldet(value: boolean) {
		this.personGemeldet = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenAksUnfallApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenAksUnfallApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'land':
					return SchadenmeldungLandApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Abreisedatum = this.abreisedatum;
		result.Datum = this.datum;
		if (this.land) {
			result.Land = this.land.toRequestObject();
		}
		result.BetroffenePerson = this.betroffenePerson;
		result.Beschreibung = this.beschreibung;
		result.Vorname = this.vorname;
		result.Nachname = this.nachname;
		result.ZustimmungDatenverarbeitung = this.zustimmungDatenverarbeitung;
		result.PersonGemeldet = this.personGemeldet;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}